import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { RepliconDialog } from '../RepliconDialog';
import StackedListMessageSummaryAlert from '../StackedListMessageSummaryAlert';

const useStyles = makeStyles(theme => ({
  dialogContent: {
    paddingTop: 0,
    paddingBottom: theme.spacing(1)
  }
}));

const AlertMessageDialog = ({
  classes: classesOverride,
  closeButtonId,
  dialogTitleId,
  isLoading,
  messageInfo,
  onClose,
  open,
  severity
}) => {
  const classes = useStyles();

  return (
    <RepliconDialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-message-dialog-title"
      classes={classesOverride}
    >
      <DialogTitle id="alert-message-dialog-title">
        <FormattedMessage id={dialogTitleId} />
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <StackedListMessageSummaryAlert
          severity={severity}
          title={messageInfo.title}
          messages={messageInfo.messages}
          isLoading={isLoading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          <FormattedMessage id={closeButtonId} />
        </Button>
      </DialogActions>
    </RepliconDialog>
  );
};

AlertMessageDialog.propTypes = {
  classes: PropTypes.object,
  closeButtonId: PropTypes.string.isRequired,
  dialogTitleId: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  messageInfo: PropTypes.shape({
    title: PropTypes.shape({
      messageId: PropTypes.string.isRequired,
      values: PropTypes.object
    }),
    messages: PropTypes.arrayOf(
      PropTypes.shape({
        messageId: PropTypes.string.isRequired,
        values: PropTypes.object
      })
    ).isRequired
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  severity: PropTypes.string.isRequired
};

export default AlertMessageDialog;
